
import Vue from "vue";
import { Contact } from "@/models/base";
import AppLabel from "@/components/common/InfoInput.vue";
import AppAddress from "./ContactInfoAddress.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { TranslateResult } from "vue-i18n";
import AppPeppolRegistrationStatus from "@/components/peppol/PeppolContactRegistrationStatus.vue";
export default Vue.extend({
	props: {
		contact: {
			type: Object as ()=>Contact,
			required: true
		}
	},
	computed: {
		contactNrLabel():TranslateResult {
			if (this.contact.GroupID > 3) {
				return this.$ct("labels.contact-nr");
			}
			return this.$ct(`labels.contact-nr-${this.contact.GroupID}`);
		},
		mainAddressTitle():TranslateResult {
			return this.$ct(`titles.address-default-${this.contact.GroupID}`);
		},
		maxRemindersText():string {
			let reminders = Object.values(this.$ct("reminders"));
			return reminders[this.contact.MaxReminder];
		},
		priceCategory():string{
			if (this.contact.SellPriceCategory == 0){
				return this.$ct("no-price-category").toString();
			}
			return DossierConfigService.getSellCategories().getCategoryName(this.contact.SellPriceCategory);
		},
		jounralName():string{
			if (this.contact.DefaultJournalID == 0){
				return "NO JOURNAL";
			}
			return DossierConfigService.getJournalsConfig().getJournalName(this.contact.DefaultJournalID);
		},
		vatRegimeName():string{
			return this.$ct((this.contact.GroupID == 2 ? "common.vat-regimes-purchase" : "common.vat-regimes") + `.${this.contact.VatRegime}`).toString();
		},
		hasMollieModuleConfigured():boolean {
			return DossierConfigService.getMollieConfig().ConnectedWithMollie;
		},
		defaultLedgerAccount():TranslateResult | string {
			if (!this.contact.DefaultLedgerAccount) {
				return this.$ct("common.none");
			}
			return this.contact.DefaultLedgerAccount.toString();
		}
	},
	components: {
		AppLabel,
		AppAddress,
		AppPeppolRegistrationStatus
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
